export default "__VITE_ASSET__C0A2YJWa__"